module.exports = __webpack_public_path__ + "img/close_x 2.abb4a5f7.svg";